import { render, staticRenderFns } from "./TextGridItem.vue?vue&type=template&id=1d39d0a6&scoped=true"
import script from "./TextGridItem.vue?vue&type=script&lang=js"
export * from "./TextGridItem.vue?vue&type=script&lang=js"
import style0 from "./TextGridItem.vue?vue&type=style&index=0&id=1d39d0a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../cortex/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d39d0a6",
  null
  
)

export default component.exports